import React from 'react';
import UserGroup from './UserGroup';

interface MessageType {
  role: string;
  date: string;
  content: string;
  userId: string;
}

interface DateGroupProps {
  date: string;
  messages: MessageType[];
  currentLang: 'es' | 'en';
  onSendMessage?: (userId: string, message: string, date: string) => void;
  expandAll?: boolean;
  assistantId: string;
}

const DateGroup: React.FC<DateGroupProps> = ({ date, messages, currentLang, onSendMessage, expandAll = false, assistantId }) => {
  // Agrupar mensajes por usuario
  const byUser = messages.reduce<Record<string, MessageType[]>>((acc, m) => {
    (acc[m.userId] = acc[m.userId] || []).push(m);
    return acc;
  }, {});
  return (
    <details className="date-group" open>
      <summary>{new Date(date).toLocaleDateString(currentLang === 'es' ? 'es-ES' : 'en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</summary>
      {Object.entries(byUser).map(([userId, userMessages]) => (
        <UserGroup
          key={userId}
          userId={userId}
          messages={userMessages}
          currentLang={currentLang}
          onSendMessage={(message) => onSendMessage && onSendMessage(userId, message, date)}
          expandAll={expandAll}
          assistantId={assistantId}
        />
      ))}
    </details>
  );
};

export default DateGroup; 